const FilterDashboardActionTypes = {
  FILTER_STATUS: 'filter/filterStatus',
  FILTER_STATUS_NURSERY: 'filter/filterStatusNursery',
  FILTER_TYPE: 'filter/filterType',
  FILTER_CYCLE: 'filter/filterCycle',
  FILTER_ORDER: 'filter/filterOrder',
  SELECTED_SPECIES: 'filter/selectedSpecies',
  CYCLES: 'filter/cycles',
  SELECTED_CYCLES: 'filter/selectedCycles',
};

export default FilterDashboardActionTypes;
